import { wxConfig, share_log_stat } from '@/api/public'
import { coursedetail, modifytaskstate } from '@/api/course'
import { getStorage, setStorage } from "@/utils/tools"
import Bus from '@/utils/bus'
import wx from "weixin-js-sdk"

// 判断是否正式环境
function isMain() {
  let root = process.env.VUE_APP_ROOT;
  return root == 'main';
}
// 格式化参数，重复的覆盖
function stringifyQuery(url) {
  let queryStr = url.split('?');
  if (queryStr.length !== 2) {
    return url
  }
  let json = {};
  let list = queryStr[1].split('&');
  if (list.length) {
    for (let arg of list) {
      let obj = arg.split('=');
      let key = obj[0];
      let val = obj[1];
      json[key] = val;
    }
  }
  delete json.source;
  let str = '';
  for (let attr in json) {
    str += (`&${attr}=${json[attr]}`);
  }
  let result = str.replace(/^&/, '?');
  return queryStr[0] + result;
}

export function execWxConfig() {
  wxConfig({
    url: location.href.split('#')[0]
  }).then(json => {
    json['jsApiList'] = ['translateVoice', 'chooseImage', 'uploadImage', 'previewImage', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone'];
    wx.config(json);
  });
}

export function shareCon(type_s, This, type_obj) {
  let filePath = isMain() ? '/main' : '/test';

  let urls = location.protocol + '//' + location.host + filePath;
  let url = urls + This.$route.fullPath;
  if (This.$route.path == "/details_new" || This.$route.path == "/details_old") {
    url = `${urls}/course_details?bid=${This.$route.query.bid}`
  }
  let chars = url ? (url.indexOf("?") > -1 ? "&" : "?") : url;
  // 传数据前This里面挂一个对象，存的就是pdk和aspx

  if (This.cacheUserConfig && JSON.stringify(This.cacheUserConfig) !== '{}') {
    let cache = This.cacheUserConfig;
    url = `${url}${chars}pdk=${cache.pdk}&aspx=${cache.aspx}`
  }
  // 7天训练营
  if (type_s == "training") {
    let shares = 0;
    if (type_obj && type_obj.share) {
      shares = type_obj.share
    }
    url = `${urls}/training_details?course_id=${This.$route.query.course_id}&share=${shares}`
  }
  // 连报
  if (type_s == "course_quote") {
    let shares = 0;
    if (type_obj && type_obj.shareuser) {
      shares = type_obj.shareuser
    }
    url = `${urls}/course_quote?joint_id=${This.$route.query.joint_id}&shareuser=${shares}`
  }
  // 拼团功能
  if (type_s == "spell") {
    let scrabble_type = 'join';
    if (type_obj && type_obj.scrabble_type == 'create') {
      url = `${urls}/course_details?bid=${This.$route.query.bid}`
    }else {
      url = `${urls}/course_spell?scrabble_id=${type_obj.scrabble_id}&scrabble_type=${scrabble_type}`
    }
  }
  // 职业发展健康指数测评（导流版）
  if (type_s == "ceping71") {
    url = `${urls}/ceping71_details`
  }
  // 职业发展健康指数测评（纯净版不收数据“重新测评”）
  if (type_s == "ceping105") {
    url = `${urls}/ceping105_details`
  }
  // 职业发展健康指数测评（导流版）
  if (type_s == "ceping96") {
    url = `${urls}/ceping96_details`
  }

  // 你适合哪类生涯赛道
  if (type_s == "ceping72") {
    url = `${urls}/ceping72_evaluation?evaluation_md5=${type_obj.evaluation_md5}&evaluation_id=${type_obj.evaluation_id}`
  }
  // 可迁移能力(学生版)
  if (type_s == "ceping76") {
    url = `${urls}/ceping76?ta_uid=${This.type_obj.evaluation_user_id}`
  }
  // 新年第一天，做自己节测评2020
  if (type_s == "ceping81" && This.$route.path=="/bemyself_rank") {
    url = `${urls}/bemyself_rank`
  }else if (type_s == "ceping81") {
    // 新年第一天，做自己节测评2020
    url = `${urls}/ceping81?uid=${This.type_obj.uid}`
  }

  // 选对小工具-咨询单商品B-2
  if (type_s == "xuandui_order") {
    url = `${urls}/xd_pay?product_name=${type_obj.name}&eid=${type_obj.eid}`
  }
  //
  url = stringifyQuery(url);
  // if (type_s == "course") {
  //   // url = `${url}${chars}pdk=${This.$route.query.pdk}${chars}aspx=${This.$route.query.aspx}`
  //   url = `${url}${chars}`;
  //   if(This.$route.query.pdk){
  //     url+= `pdk=${This.$route.query.pdk}`;
  //   }
  //   if(This.$route.query.aspx){
  //     url+= `aspx=${This.$route.query.aspx}`;
  //   }
  // }
  // 课程分享
  let dispatcs = (style, courseType) => {

    coursedetail({
        bid: (courseType && courseType == 'course2') ? 2 : 1
      })
      .then((data) => {
        // 神策统计--分享成功后
        sensors.track('recommendCourse', {
          course_id: String(data.id),
          course_name: data.coursename,
          recommend_page_url: url,
          recommend_page_title: document.title,
          recommend_page_style: style,
        });
      })
  };
  // 测评分享
  let mes_obj = {};
  let mes_dispatcs = (style, mes_obj, share_num) => {
    Bus.$emit('shareSuccess',true);
    // 神策统计--分享成功后
    sensors.track('shareEvaluation', {
      evaluation_id: mes_obj.evaluation_id,
      evaluation_name: mes_obj.evaluation_name,
      evaluation_user_id: mes_obj.evaluation_user_id,
      share_style: style,
      share_num: share_num
    });
  };
  // 7天训练营分享
  let training_obj = {};
  let training_dispatcs = (style, training_obj, share_num) => {
    // 神策统计--分享成功后
    sensors.track('recommendCourse', {
      course_id: training_obj.train_id,
      course_name: training_obj.train_name,
      recommend_page_url: url,
      recommend_page_title: document.title,
      recommend_page_style: style,
    });
  };
  let shareConfig_fg = {
    index: {
      title: "新精英人才加速器",
      desc: "你的升职加薪必备神器",
      link: url,
      type: 0,
      imgUrl: 'https://themes-cdn.xjy.cn/statics/career/images/up.png'
    },
    course: {
      title: "30天重塑核心竞争力，提升你的职业身价！",
      desc: "职业发展上升期必修课",
      link: url,
      type: 1,
      imgUrl: 'https://themes-cdn.xjy.cn/statics/career/images/up.png',
    },
    totoring: {
      title: "生涯咨询师1V1指导——量身定制你的竞争力提升方案",
      desc: "量身定制你的竞争力提升方案",
      link: url,
      type: 0,
      imgUrl: 'https://themes-cdn.xjy.cn/statics/career/images/up.png'
    },
    measurement: {
      title: "职业发展健康指数测评，为发展加速！",
      desc: "如题～",
      link: url,
      type: 2,
      imgUrl: 'https://themes-cdn.xjy.cn/statics/career/images/up.png'
    },
    measurement_new: {
      title: "职业发展健康指数测评，为发展加速！",
      desc: "我们的“心灵剧本”写于童年和原生家庭，长大后在职场重现着",
      link: url,
      type: 3,
      imgUrl: 'https://themes-cdn.xjy.cn/statics/career/images/up.png'
    },
    ceping47: {
      title: "给你分享了原生家庭与职场的好文章与测评！",
      desc: "如题～",
      link: 'https://api.xjy.cn/chengzi/share/jump/id/NWNkNGUzYTFiZmE1ZQ',
      type: 4,
      imgUrl: 'https://misc.xjy.cn/icon/icon_family.png'
    },
    drawing: {
      title: "这是我得的潜意识",
      desc: "通过绘画发现你的职场潜意识",
      link: url,
      type: 5,
      imgUrl: 'https://themes-cdn.xjy.cn/statics/career/images/drawing_shra.png'
    },
    training: {
      title: "{微信昵称}正在参加【{特训营名称}】，求拼团组队～",
      desc: "清晰的职业发展是一种怎样的体验？",
      link: url,
      type: 6,
      imgUrl: 'https://themes-cdn.xjy.cn/statics/career/images/training_icon.png'
    },
    ceping62: {
      title: "给你分享工作家庭平衡状态测评",
      desc: "如题～",
      link: url,
      type: 7,
      imgUrl: 'https://themes-cdn.xjy.cn/statics/career/images/up.png'
    },
    ceping: {
      title: "测评模板",
      desc: "如题～",
      link: url,
      type: 8,
      imgUrl: 'https://themes-cdn.xjy.cn/statics/career/images/up.png'
    },
    course2: {
      title: "21天自我探索课，发现最佳工作模式",
      desc: "人人都需要的自我探索课",
      link: url,
      type: 9,
      imgUrl: 'https://themes-cdn.xjy.cn/statics/career/images/up.png',
    },
    course_quote: {
      title: "XX邀请你，开启高燃职业态",
      desc: "给你推荐人才加速器的两门精品训练营，完成职业和自我的深度探索",
      link: url,
      type: 10,
      imgUrl: 'https://themes-cdn.xjy.cn/statics/career/images/up.png',
    },
    spell: {
      title: "30天重塑核心竞争力，提升你的职业身价！",
      desc: "职业发展上升期必修课",
      link: url,
      type: 11,
      imgUrl: 'https://themes-cdn.xjy.cn/statics/career/images/up.png',
    },
    ceping54: {
      title: "瘦身释放我的内心“野兽",
      desc: "如题～",
      link: url,
      type: 12,
      imgUrl: 'https://themes-cdn.xjy.cn/statics/career/images/up.png'
    },
    ceping68: {
      title: "能力探索",
      desc: "你知道你有哪些能力吗？你知道哪些能力是你的甜蜜点，越用越有满足感吗？你知道有哪些能力是你越用越有挫败感却不知道该怎么办的吗？",
      link: url,
      type: 13,
      imgUrl: 'https://statics-cdn.xjy.cn/images/xjylogo.png'
    },
    ceping71: {
      title: "我发现了一个有趣的职场体检测评",
      desc: "快来测测你的职场健康指数是多少吧~",
      link: url,
      type: 14,
      imgUrl: 'https://themes-cdn.xjy.cn/statics/career/images/up.png'
    },
    ceping105: {
      title: "我发现了一个有趣的职场体检测评",
      desc: "快来测测你的职场健康指数是多少吧~",
      link: url,
      type: 14,
      imgUrl: 'https://themes-cdn.xjy.cn/statics/career/images/up.png'
    },
    ceping96: {
      title: "我发现了一个有趣的职场体检测评",
      desc: "快来测测你的职场健康指数是多少吧~",
      link: url,
      type: 24,
      imgUrl: 'https://themes-cdn.xjy.cn/statics/career/images/up.png'
    },
    ceping73: {
      title: "快来看看你对什么职业感兴趣吧   测一测",
      desc: "如题～",
      link: url,
      type: 15,
      imgUrl: 'https://themes-cdn.xjy.cn/statics/career/images/up.png'
    },
    ceping74: {
      title: "你的职场代言神兽是什么？快来测一测吧",
      desc: "如题～",
      link: url,
      type: 16,
      imgUrl: 'https://themes-cdn.xjy.cn/statics/career/images/up.png'
    },
    ceping72: {
      title: "我的测评报告",
      desc: "如题～",
      link: url,
      type: 17,
      imgUrl: 'https://themes-cdn.xjy.cn/statics/career/images/up.png'
    },
    ceping76: {
      title: "大学生涯,知我如你,快来反馈下我的优势有哪些吧~",
      desc: "你的反馈对我很重要,评完有彩蛋哦~",
      link: url,
      type: 18,
      imgUrl: 'https://themes-cdn.xjy.cn/statics/career/images/up.png'
    },
    ceping69: {
      title: "职业兴趣探索，发现你的职业潜能",
      desc: "如题～",
      link: url,
      type: 19,
      imgUrl: 'https://themes-cdn.xjy.cn/statics/career/images/up.png'
    },
    ceping81: {
      title: "新年第一天，我要做自己",
      desc: "如题～",
      link: url,
      type: 20,
      imgUrl: 'https://themes-cdn.xjy.cn/statics/career/images/up.png'
    },
    ceping83: {
      title: "职业现状测评",
      desc: "助力你的职场发展",
      link: url,
      type: 20,
      imgUrl: 'https://themes-cdn.xjy.cn/statics/career/images/up.png'
    },
    beMyself: {
      title: "新精英各地线下活动开启售票！",
      desc: "成长，长成自己的样子",
      link: url,
      type: 21,
      imgUrl: 'https://statics-cdn.xjy.cn/images/xjylogo.png'
    },
    measurement_list:{
      title: "新精英专业测评列表",
      desc: "自我了解工具+生涯咨询与教学助手",
      link: url,
      type: 22,
      imgUrl: 'https://themes-cdn.xjy.cn/statics/career/images/up.png'
    },
    xuandui_order:{
      title: "选对，帮助你选择正确！",
      desc: "如题～",
      link: url,
      type: 23,
      imgUrl: 'https://themes-cdn.xjy.cn/statics/career/images/up.png'
    },
  };
  wx.ready(function() {
    let shareConfig = {};
    if (type_s == "index") {
      shareConfig = shareConfig_fg.index;
    } else if (type_s == "totoring") {
      shareConfig = shareConfig_fg.totoring;
    } else if (type_s == "course2") {
      shareConfig = shareConfig_fg.course2;
      if (type_obj && type_obj != {}) {
        shareConfig.title = type_obj.type_title
      }
    } else if (type_s == "course") {
      shareConfig = shareConfig_fg.course;
      if (type_obj && type_obj != {}) {
        shareConfig.title = type_obj.type_title
      }
    } else if (type_s == "measurement") {
      shareConfig = shareConfig_fg.measurement;
      if (type_obj && type_obj != {}) {
        if (type_obj.nickname) {
          shareConfig.title = type_obj.nickname + "邀请你帮Ta完成职业发展测评";
          shareConfig.desc = "你的评价对ta非常重要，完成后你将获得免费测评～";
        }
        mes_obj = type_obj;
      }
    } else if (type_s == "measurement_new") {
      shareConfig = shareConfig_fg.measurement_new;
      if (type_obj && type_obj != {}) {
        if (type_obj.nickname) {
          shareConfig.title = type_obj.nickname + "探索可迁移能力，应对裁员时代";
          shareConfig.desc = "洞察四维度12项能力现状，明晰个人优劣势";
        }
        mes_obj = type_obj;
      }
    } else if (type_s == "ceping47") {
      shareConfig = shareConfig_fg.ceping47;
      if (type_obj && type_obj != {}) {
        if (type_obj.nickname) {
          shareConfig.title = type_obj.nickname + "给你分享了原生家庭与职场的好文章与测评！";
          shareConfig.desc = "我们的“心灵剧本”写于童年和原生家庭，长大后在职场重现着";
        }
        mes_obj = type_obj;
      }
    } else if (type_s == "ceping54") {
      shareConfig = shareConfig_fg.ceping54;
      if (type_obj && type_obj != {}) {
        // if (type_obj.nickname) {
        //   shareConfig.title = type_obj.nickname + "给你分享了原生家庭与职场的好文章与测评！";
        //   shareConfig.desc = "我们的“心灵剧本”写于童年和原生家庭，长大后在职场重现着";
        // }
        mes_obj = type_obj;
      }
    } else if (type_s == "drawing") {
      shareConfig = shareConfig_fg.drawing;
      if (type_obj && type_obj != {}) {
        if (type_obj.nickname) {
          shareConfig.title = '这是' + type_obj.nickname + "的潜意识";
          shareConfig.desc = "通过绘画发现你的职场潜意识";
        }
        mes_obj = type_obj;
      }
    } else if (type_s == "training") {
      shareConfig = shareConfig_fg.training;
      if (type_obj && type_obj != {}) {
        if (type_obj.nickname) {
          shareConfig.title = `${type_obj.nickname}正在参加【${type_obj.train_name}】，求拼团组队～`
        }
        training_obj = type_obj;
      } else {
        shareConfig.title = document.title;
      }
    } else if (type_s == "ceping62") {
      shareConfig = shareConfig_fg.ceping62;
      if (type_obj && type_obj != {}) {
        if (type_obj.nickname) {
          shareConfig.title = type_obj.nickname + "给你分享了工作家庭平衡状态测评";
          shareConfig.desc = "从工作家庭冲突和工作家庭促进两个方面全面评估工作家庭平衡状态";
        }
        mes_obj = type_obj;
      }
    } else if (type_s == "ceping") {
      shareConfig = shareConfig_fg.ceping;
      if (type_obj && type_obj != {}) {
        if (type_obj.headtitle) {
          shareConfig.title = type_obj.headtitle;
        }
        mes_obj = type_obj;
      }
    } else if (type_s == "course_quote") {
      shareConfig = shareConfig_fg.course_quote;
      if (type_obj && type_obj != {}) {
        if (type_obj.nickname) {
          shareConfig.title = `${type_obj.nickname}邀请你，开启高燃职业态`;
          shareConfig.desc = "给你推荐人才加速器的两门精品训练营，完成职业和自我的深度探索";
        }
      } else {
        shareConfig.title = document.title;
      }
    } else if (type_s == "spell") {
      shareConfig = shareConfig_fg.course_quote;
      if (type_obj && type_obj != {}) {
        if (type_obj.scrabble_type !='create') {
          shareConfig.title = `【仅剩${type_obj.surplus}名额】我已报名《${type_obj.bigcoursename}》，邀请你一起来参加！`;
          shareConfig.desc = type_obj.bid=='1'?"用4周时间重塑你的个人商业价值，打造3年职业发展路径。":"用3周时间完成深度自我探索和梳理，找到你的最佳工作模式，开启超燃职业态。";
        }
      } else {
        shareConfig.title = document.title;
      }
    }else if (type_s == "ceping68") {
      shareConfig = shareConfig_fg.ceping68;
      if (type_obj && type_obj != {}) {
        // if (type_obj.nickname) {
        //   shareConfig.title = type_obj.nickname + "给你分享了原生家庭与职场的好文章与测评！";
        //   shareConfig.desc = "我们的“心灵剧本”写于童年和原生家庭，长大后在职场重现着";
        // }
        mes_obj = type_obj;
      }
    }else if (type_s == "ceping71") {
      shareConfig = shareConfig_fg.ceping71;
      if (type_obj && type_obj != {}) {
        // if (type_obj.nickname) {
        //   shareConfig.title = type_obj.nickname + "给你分享了原生家庭与职场的好文章与测评！";
        //   shareConfig.desc = "我们的“心灵剧本”写于童年和原生家庭，长大后在职场重现着";
        // }
        mes_obj = type_obj;
      }
    }else if (type_s == "ceping105") {
      shareConfig = shareConfig_fg.ceping105;
      if (type_obj && type_obj != {}) {
        // if (type_obj.nickname) {
        //   shareConfig.title = type_obj.nickname + "给你分享了原生家庭与职场的好文章与测评！";
        //   shareConfig.desc = "我们的“心灵剧本”写于童年和原生家庭，长大后在职场重现着";
        // }
        mes_obj = type_obj;
      }
    } else if (type_s == "ceping96") {
      shareConfig = shareConfig_fg.ceping96;
      if (type_obj && type_obj != {}) {
        // if (type_obj.nickname) {
        //   shareConfig.title = type_obj.nickname + "给你分享了原生家庭与职场的好文章与测评！";
        //   shareConfig.desc = "我们的“心灵剧本”写于童年和原生家庭，长大后在职场重现着";
        // }
        mes_obj = type_obj;
      }
    } else if (type_s == "ceping73") {
      shareConfig = shareConfig_fg.ceping73;
      if (type_obj && type_obj != {}) {
        mes_obj = type_obj;
      }
    } else if (type_s == "ceping74") {
      shareConfig = shareConfig_fg.ceping74;
      if (type_obj && type_obj != {}) {
        mes_obj = type_obj;
      }
    } else if (type_s == "ceping72") {
      shareConfig = shareConfig_fg.ceping72;
      if (type_obj && type_obj != {}) {
        mes_obj = type_obj;
      }
      if(type_obj && type_obj.nickname) {
        shareConfig.title = `${type_obj.nickname}的测评报告`;
      }
    }else if (type_s == "ceping76") {
      shareConfig = shareConfig_fg.ceping76;
      if (type_obj && type_obj != {}) {
        mes_obj = type_obj;
      }
    }else if (type_s == "ceping69") {
      shareConfig = shareConfig_fg.ceping69;
      if (type_obj && type_obj != {}) {
        mes_obj = type_obj;
      }
    }else if (type_s == "ceping81") {
      shareConfig = shareConfig_fg.ceping81;
      if (type_obj && type_obj != {}) {
        mes_obj = type_obj;
      }
    }else if (type_s == "ceping83") {
      shareConfig = shareConfig_fg.ceping83;
      if (type_obj && type_obj != {}) {
        mes_obj = type_obj;
      }
    }else if (type_s == "beMyself") {
      shareConfig = shareConfig_fg.beMyself;
      if (type_obj && type_obj != {}) {
        mes_obj = type_obj;
      }
    }else if (type_s == "measurement_list") {
      shareConfig = shareConfig_fg.measurement_list;
      if (type_obj && type_obj != {}) {
        mes_obj = type_obj;
      }
    }else{
      shareConfig = shareConfig_fg.index;
    };
    // 判读是否是绘画测评
    let str = shareConfig.link ? (shareConfig.link.indexOf("?") > -1 ? "&" : "?") : url;
    if (shareConfig.type == 5) {
      shareConfig.link = shareConfig.link.split("?")[0];
      shareConfig.link = shareConfig.link + '?' + type_obj.path.split("?")[1];
    }

    var character = shareConfig.link ? (shareConfig.link.indexOf("?") > -1 ? "&" : "?") : url;

    wx.onMenuShareTimeline({
      title: shareConfig.title,
      desc: shareConfig.desc,
      link: shareConfig.link + character + 'source=wxf',
      imgUrl: shareConfig.imgUrl,
      success: function() {
        // '分享给朋友圈';
        if (shareConfig.type == 1) {
          dispatcs("分享给朋友圈");
        } else if (shareConfig.type == 2) {
          let share_num = getStorage(type_obj.path, 'num') ? getStorage(type_obj.path, 'num') : 0;
          share_num += 1;
          setStorage(type_obj.path, 'num', share_num);
          mes_dispatcs("分享给朋友圈 ", type_obj, share_num);
        } else if (shareConfig.type == 3) {
          let share_num = getStorage(type_obj.path, 'measurementNew_num') ? getStorage(type_obj.path, 'measurementNew_num') : 0;
          share_num += 1;
          setStorage(type_obj.path, 'measurementNew_num', share_num);
          mes_dispatcs("分享给朋友圈 ", type_obj, share_num);
        } else if (shareConfig.type == 4) {
          This.set_show_market();
          let share_num = getStorage(type_obj.path, 'ceping47') ? getStorage(type_obj.path, 'ceping47') : 0;
          share_num += 1;
          setStorage(type_obj.path, 'ceping47', share_num);
          mes_dispatcs("分享给朋友圈 ", type_obj, share_num);
        } else if (shareConfig.type == 5) {
          let share_num = getStorage(type_obj.path, 'drawing') ? getStorage(type_obj.path, 'drawing') : 0;
          share_num += 1;
          setStorage(type_obj.path, 'drawing', share_num);
          mes_dispatcs("分享给朋友圈 ", type_obj, share_num);
        } else if (shareConfig.type == 6) {
          let share_num = getStorage(type_obj.path, 'training') ? getStorage(type_obj.path, 'training') : 0;
          share_num += 1;
          setStorage(type_obj.path, 'training', share_num);
          training_dispatcs("分享给朋友圈 ", type_obj, share_num);
        } else if (shareConfig.type == 7) {
          This.set_show_market();
          let share_num = getStorage(type_obj.path, 'ceping62') ? getStorage(type_obj.path, 'ceping62') : 0;
          share_num += 1;
          setStorage(type_obj.path, 'ceping62', share_num);
          mes_dispatcs("分享给朋友圈 ", type_obj, share_num);
        } else if (shareConfig.type == 8) {
          This.set_show_market();
          let share_num = getStorage(type_obj.path, 'ceping') ? getStorage(type_obj.path, 'ceping') : 0;
          share_num += 1;
          setStorage(type_obj.path, 'ceping', share_num);
          mes_dispatcs("分享给朋友圈 ", type_obj, share_num);
        } else if (shareConfig.type == 9) {
          dispatcs("分享给朋友圈", 'course2');
        } else if (shareConfig.type == 10) {
          dispatcs("分享给朋友圈", 'course_quote');
        } else if (shareConfig.type == 11) {
          dispatcs("分享给朋友圈", 'spell');
        } else if (shareConfig.type == 12) {
          mes_dispatcs("分享给朋友圈", 'ceping54');
        } else if (shareConfig.type == 13) {
          mes_dispatcs("分享给朋友圈", 'ceping68');
        } else if (shareConfig.type == 14) {
          mes_dispatcs("分享给朋友圈", 'ceping71');
          setStorage(type_obj.path, 'sharing_posters', true);
        } else if (shareConfig.type == 24) {
          mes_dispatcs("分享给朋友圈", 'ceping96');
          setStorage(type_obj.path, 'sharing_posters', true);
        } else if (shareConfig.type == 15) {
          mes_dispatcs("分享给朋友圈", 'ceping73');
        } else if (shareConfig.type == 16) {
          mes_dispatcs("分享给朋友圈", 'ceping74');
        } else if (shareConfig.type == 17) {
          mes_dispatcs("分享给朋友圈", 'ceping72');
        } else if (shareConfig.type == 18) {
          mes_dispatcs("分享给朋友圈", 'ceping76');
        } else if (shareConfig.type == 19) {
          mes_dispatcs("分享给朋友圈", 'ceping69');
        } else if (shareConfig.type == 20) {
          mes_dispatcs("分享给朋友圈", 'ceping81');
        }else if (shareConfig.type == 21) {
          mes_dispatcs("分享给朋友圈", 'beMyself');
        }else if (shareConfig.type == 22) {
          mes_dispatcs("分享给朋友圈", 'measurement_list');
        }else if (shareConfig.type == 23) {
          mes_dispatcs("分享给朋友圈", 'xuandui_order');
        }else{
          dispatcs("分享给朋友圈");
        }
      },
    });
    wx.onMenuShareAppMessage({
      title: shareConfig.title,
      desc: shareConfig.desc,
      link: shareConfig.link + character + 'source=wx',
      imgUrl: shareConfig.imgUrl,
      success: function() {
        //      '分享给朋友';
        if (shareConfig.type == 1) {
          dispatcs("分享给朋友");
        } else if (shareConfig.type == 2) {
          let share_num = getStorage(type_obj.path, 'num') ? getStorage(type_obj.path, 'num') : 0;
          share_num += 1;
          setStorage(type_obj.path, 'num', share_num);
          mes_dispatcs("分享给朋友", type_obj, share_num);
        } else if (shareConfig.type == 3) {
          let share_num = getStorage(type_obj.path, 'measurementNew_num') ? getStorage(type_obj.path, 'measurementNew_num') : 0;
          share_num += 1;
          setStorage(type_obj.path, 'measurementNew_num', share_num);
          mes_dispatcs("分享给朋友 ", type_obj, share_num);
        } else if (shareConfig.type == 4) {
          This.set_show_market();
          let share_num = getStorage(type_obj.path, 'ceping47') ? getStorage(type_obj.path, 'ceping47') : 0;
          share_num += 1;
          setStorage(type_obj.path, 'ceping47', share_num);
          mes_dispatcs("分享给朋友 ", type_obj, share_num);
        } else if (shareConfig.type == 5) {
          let share_num = getStorage(type_obj.path, 'drawing') ? getStorage(type_obj.path, 'drawing') : 0;
          share_num += 1;
          setStorage(type_obj.path, 'drawing', share_num);
          mes_dispatcs("分享给朋友 ", type_obj, share_num);
        } else if (shareConfig.type == 6) {
          let share_num = getStorage(type_obj.path, 'training') ? getStorage(type_obj.path, 'training') : 0;
          share_num += 1;
          setStorage(type_obj.path, 'training', share_num);
          training_dispatcs("分享给朋友 ", type_obj, share_num);
        } else if (shareConfig.type == 7) {
          This.set_show_market();
          let share_num = getStorage(type_obj.path, 'ceping62') ? getStorage(type_obj.path, 'ceping62') : 0;
          share_num += 1;
          setStorage(type_obj.path, 'ceping62', share_num);
          mes_dispatcs("分享给朋友 ", type_obj, share_num);
        } else if (shareConfig.type == 8) {
          This.set_show_market();
          let share_num = getStorage(type_obj.path, 'ceping') ? getStorage(type_obj.path, 'ceping') : 0;
          share_num += 1;
          setStorage(type_obj.path, 'ceping', share_num);
          mes_dispatcs("分享给朋友 ", type_obj, share_num);
        } else if (shareConfig.type == 9) {
          dispatcs("分享给朋友", 'course2');
        } else if (shareConfig.type == 10) {
          dispatcs("分享给朋友", 'course_quote');
        } else if (shareConfig.type == 11) {
          dispatcs("分享给朋友", 'spell');
        } else if (shareConfig.type == 12) {
          mes_dispatcs("分享给朋友", 'ceping54');
        } else if (shareConfig.type == 13) {
          mes_dispatcs("分享给朋友", 'ceping68');
        } else if (shareConfig.type == 14) {
          mes_dispatcs("分享给朋友", 'ceping71');
          setStorage(type_obj.path, 'sharing_posters', true);
        } else if (shareConfig.type == 24) {
          mes_dispatcs("分享给朋友", 'ceping96');
          setStorage(type_obj.path, 'sharing_posters', true);
        } else if (shareConfig.type == 15) {
          mes_dispatcs("分享给朋友", 'ceping73');
        } else if (shareConfig.type == 16) {
          mes_dispatcs("分享给朋友", 'ceping74');
        } else if (shareConfig.type == 17) {
          mes_dispatcs("分享给朋友", 'ceping72');
        } else if (shareConfig.type == 18) {
          mes_dispatcs("分享给朋友", 'ceping76');
        } else if (shareConfig.type == 19) {
          mes_dispatcs("分享给朋友", 'ceping69');
        } else if (shareConfig.type == 20) {
          mes_dispatcs("分享给朋友", 'ceping81');
        }else if (shareConfig.type == 21) {
          mes_dispatcs("分享给朋友", 'beMyself');
        }else if (shareConfig.type == 22) {
          mes_dispatcs("分享给朋友", 'measurement_list');
        }else if (shareConfig.type == 23) {
          mes_dispatcs("分享给朋友", 'xuandui_order');
        }else{
          mes_dispatcs("分享给朋友");
        }
      },
    });
    wx.onMenuShareWeibo({
      title: shareConfig.title,
      desc: shareConfig.desc,
      link: shareConfig.link,
      imgUrl: shareConfig.imgUrl,
      success: function() {
        //      '分享到腾讯微博';
      },
    });
  });
}

// function share_log(type_, link_) {
//   var share_from_ = (type_ == 'wxf' ? 'onMenuShareTimeline' : 'onMenuShareAppMessage');
//   modifytaskstate({
//       cid: cid_,
//       share_url: link_,
//       share_from: share_from_
//     })
//     .then((data) => {})
// }
